import { PermissionResource } from '@coin/shared/core/util-enums';
import { TreeNode } from '../route-builder';

export const EmploymentConditionsLibraryModule = {
  segment: 'employment-conditions-library',
  title: 'home.employment-conditions-library',
  navigationRoot: true,
  emptyPage: true,
  children: {
    SignatureAuthorizationsComponent: {
      segment: 'signature-authorizations',
      title: 'employment-conditions-library.signature-authorizations-headline',
      icon: 'settings_applications',
      permissions: [PermissionResource.EmploymentConditionLibrarySignatureAuthorizationAdmin]
    },
    EclEmployeesComponent: {
      segment: 'ecl-employees',
      title: 'employment-conditions-library.ecl-employees-headline',
      icon: 'people_alt',
      permissions: [
        PermissionResource.EmploymentConditionLibraryAdmin,
        PermissionResource.EmploymentConditionLibraryRestricted,
        PermissionResource.EmploymentConditionLibraryGenerator
      ],
      children: {
        EmployeeAttributesComponent: {
          segment: 'attributes',
          params: ['employeeId'],
          title: 'employment-conditions-library.ecl-employee-attributes-headline'
        }
      }
    },
    EclAttributesComponent: {
      segment: 'attributes',
      title: 'employment-conditions-library.ecl-attributes-headline',
      icon: 'attribution',
      permissions: [PermissionResource.EmploymentConditionLibraryAdmin],
      params: ['attributeType']
    },
    EclLegalEntitiesComponent: {
      segment: 'legal-entities',
      title: 'employment-conditions-library.legal-entities-headline',
      icon: 'co_present',
      permissions: [PermissionResource.EmploymentConditionLibraryAdmin],
      children: {
        LegalEntitiesAttributesComponent: {
          segment: 'attributes',
          params: ['entityId'],
          title: 'employment-conditions-library.legal-entities-attributes-headline'
        }
      }
    },
    EclCategoriesComponent: {
      segment: 'categories',
      title: 'employment-conditions-library.categories-headline',
      icon: 'category',
      permissions: [PermissionResource.EmploymentConditionLibraryAdmin],
      params: ['type', 'clusterId', 'subjectId']
    },
    EclMailTemplatesComponent: {
      segment: 'mail-templates',
      title: 'employment-conditions-library.mail-templates-headline',
      icon: 'mail',
      permissions: [PermissionResource.EmploymentConditionLibraryAdmin]
    },
    EclApproversComponent: {
      segment: 'approvers',
      title: 'employment-conditions-library.approvers-headline',
      icon: 'verified_user',
      permissions: [PermissionResource.EmploymentConditionLibraryAdmin]
    },
    EclCountryNumbersSettingsComponent: {
      segment: 'country-number-settings',
      title: 'employment-conditions-library.number-settings.headline',
      icon: 'numbers',
      permissions: [PermissionResource.EmploymentConditionLibraryAdmin]
    }
  }
} as const satisfies TreeNode;
